export default "__VITE_ASSET__DQ8mB2FI__"